__webpack_require__.p = "https://cdn.brandwatch.com/shared-dashboard-wrapper/d9283b742701755b57eff2e15883967f018ae568/";